import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'
import { CardImageText } from './card-image-text.tsx'
import { Icon } from './icon.tsx'

export interface InsuranceCardProps {
	/**
	 * Insurance type title
	 */
	title: string
	/**
	 * Icon name for the insurance type
	 */
	iconName: string
	/**
	 * Card color variant
	 */
	color?: 'blue' | 'green'
	/**
	 * Additional CSS classes
	 */
	className?: string
	/**
	 * Click handler
	 */
	onClick?: () => void
}

const InsuranceCard = React.forwardRef<HTMLDivElement, InsuranceCardProps>(
	({ title, iconName, color = 'blue', className, onClick, ...props }, ref) => {
		return (
			<CardImageText
				ref={ref}
				color={color}
				height={206}
				title={title}
				icon={<Icon name={iconName as any} className="size-10" />}
				className={cn(
					'w-[140px] min-w-[140px] cursor-pointer md:w-[220px] md:min-w-[200px]',
					className,
				)}
				onClick={onClick}
				{...props}
			/>
		)
	},
)

InsuranceCard.displayName = 'InsuranceCard'

export { InsuranceCard }
